import { useState, useEffect } from "react";
import { RouteComponentProps, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Member } from "../../utils/types";
import { useAlert } from "../../hooks/useAlert";
import StoreCollectionsTable from "../organizations/components/StoreCollectionsTable";
import InputBox from "../../components/input-box";
import { WithContext as ReactTags, Tag } from "react-tag-input";
import { api, getMember } from "../../services/axios";
import { toast } from "sonner";

const initialData: Member = {
  activity: "",
  sports: "",
  org_salesforce_id: "",
  status: "",
  salesforce_id: "",
  hometown: "",
  full_name: "",
  college: "",
  updated_at: "",
  last_name: "",
  number: "",
  first_name: "",
  id: "",
  position: "",
  tags: [],
  college_salesforce_id: "",
};
const KeyCodes = {
  enter: 13,
};

const delimiters = [KeyCodes.enter];

type TParams = { id: string };

export const MemberPage = (props: RouteComponentProps<TParams>) => {
  const history = useHistory();
  const alert = useAlert();

  const [member, setMember] = useState(initialData);
  const [tagInputValue, setTagInputValue] = useState("");

  const ID = props.match.params.id;

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...member,
      tags: member.tags
        ? member.tags.map(function (x) {
            return { id: x, text: x };
          })
        : [],
    },
    validationSchema: Yup.object({
      first_name: Yup.string().min(1).max(30).required("Required"),
      last_name: Yup.string().min(1).max(30).required("Required"),
      number: Yup.string().min(1).max(30).required("Required"),
      salesforce_id: Yup.string().min(1).max(30).required("Required"),
      status: Yup.string().required("Required"),
    }),
    onSubmit: async (formData) => {
      try {
        let newTags = formData.tags?.map(function (x) {
          let tag = x as any;
          return tag.text;
        });
        console.log("formData", formData);
        await api
          .put(`athletes/${member.id}`, { ...formData, tags: newTags })
          .then(() => toast.success("saved", { duration: 5000 }))
          .catch((e) => toast.error(e.message, { duration: 5000 }));
      } catch (e: any) {
        console.log("ERORR", e);
      }
    },
  });

  const fetchMember = async () => {
    console.log("ID", ID);
    const result = (await getMember(ID)) as unknown as Member;
    console.log("result", result);
    setMember({ ...member, ...result });
  };

  async function runAuto() {
    try {
      await api
        .put(`athletes/${member.id}`, { auto_run: true })
        .then(() => toast.success("saved", { duration: 5000 }))
        .catch((e) => toast.error(e.message, { duration: 5000 }));
    } catch (e: any) {
      console.log("ERORR", e);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);

    fetchMember();

    formik.resetForm();
  }, []);

  function goBack() {
    history.push({
      pathname: `/organization/${member.org_salesforce_id}`,
    });
  }

  const handleDelete = (i: number) => {
    const next = formik
      .getFieldProps("tags")
      .value.filter((tag: Tag, index: number) => index !== i);
    formik.setFieldValue("tags", next);
  };

  const handleAddition = (tag: Tag) => {
    const next = [...formik.getFieldProps("tags").value, tag];
    formik.setFieldValue("tags", next);
  };

  useEffect(() => {
    if (formik.submitCount > 0 && !formik.isValid) {
      alert.showAlert(
        "Error saving!",
        "Some fields are not valid please check and try again.",
        "Error"
      );
    }
  }, [formik.submitCount, formik.isValid]);

  return (
    <div className="m-8 p-24">
      <div
        className="underline cursor-pointer text-deeppurple mb-10"
        onClick={() => goBack()}
      >
        Back to organization
      </div>

      <h1 className="bold text-2xl">
        full_name: {member.full_name ? member.full_name : "no full name"}
      </h1>
      <h1 className="bold text-2xl">
        salesforce_id:
        {member.salesforce_id ? member.salesforce_id : "no salesforce id"}
      </h1>
      <div className="my-8  w-full border border-b  rounded mb-16">
        <h3 className="bold text-xl border-b mb-8 p-4">
          Configurable Product Values
        </h3>
        <div className="w-full md:w-1/2 lg:w-2/5 p-4">
          <InputBox
            type="text"
            placeholder="First name: {athlete-first_name}"
            label="First Name"
            name={formik.getFieldProps("first_name").name}
            value={formik.getFieldProps("first_name").value}
            onChange={formik.getFieldProps("first_name").onChange}
            onBlur={formik.getFieldProps("first_name").onBlur}
            touched={formik.touched.first_name}
            error={formik.errors.first_name}
          />
          <InputBox
            type="text"
            placeholder="Last name: {athlete-last_name}"
            label="Last name"
            name={formik.getFieldProps("last_name").name}
            value={formik.getFieldProps("last_name").value}
            onChange={formik.getFieldProps("last_name").onChange}
            onBlur={formik.getFieldProps("last_name").onBlur}
            touched={formik.touched.last_name}
            error={formik.errors.last_name}
          />
          <div className="mb-2">
            <label
              htmlFor="location"
              className="block text-sm font-medium text-gray-700"
            >
              Status
            </label>
            <select
              id="status"
              name={formik.getFieldProps("status").name}
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              value={formik.getFieldProps("status").value || ""}
              onChange={formik.getFieldProps("status").onChange}
              onBlur={formik.getFieldProps("status").onBlur}
            >
              <option>active</option>
              <option>inactive</option>
            </select>
          </div>
          <InputBox
            type="text"
            placeholder="Number: {athlete-number}"
            label="Number"
            name={formik.getFieldProps("number").name}
            value={formik.getFieldProps("number").value}
            onChange={formik.getFieldProps("number").onChange}
            onBlur={formik.getFieldProps("number").onBlur}
            touched={formik.touched.number}
            error={formik.errors.number}
          />
          <InputBox
            type="text"
            placeholder="Position: {athlete-position}"
            label="Position"
            name={formik.getFieldProps("position").name}
            value={formik.getFieldProps("position").value}
            onChange={formik.getFieldProps("position").onChange}
            onBlur={formik.getFieldProps("position").onBlur}
            touched={formik.touched.position}
            error={formik.errors.position}
          />
          <InputBox
            type="text"
            placeholder="Sports: {athlete-sports}"
            label="Sports"
            name={formik.getFieldProps("sports").name}
            value={formik.getFieldProps("sports").value}
            onChange={formik.getFieldProps("sports").onChange}
            onBlur={formik.getFieldProps("sports").onBlur}
            touched={formik.touched.sports}
            error={formik.errors.sports}
          />
          <div className="mt-12">
            <label
              htmlFor="text"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Custom Product Tags
            </label>
            <ReactTags
              autofocus={false}
              inputValue={tagInputValue}
              handleInputChange={setTagInputValue}
              tags={formik.getFieldProps("tags").value}
              delimiters={delimiters}
              allowDeleteFromEmptyInput={false}
              handleDelete={handleDelete}
              handleAddition={handleAddition}
              classNames={{
                tag: '" mx-2 inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-gray-100 text-gray-800"',
                tagInputField:
                  "mt-2 shadow-sm block w-full sm:text-sm border-gray-300 rounded-md",

                tagInput:
                  "shadow-sm block w-full sm:text-sm border-gray-300 rounded-md",
              }}
            />
            <button
              type="submit"
              onClick={() => {
                handleAddition({ id: tagInputValue, text: tagInputValue });
                setTagInputValue("");
              }}
              disabled={tagInputValue.length === 0}
              className="mt-2 bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
            >
              Add Tag
            </button>
          </div>
        </div>
        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <button
            type="submit"
            onClick={formik.submitForm}
            className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
          >
            Save
          </button>
        </div>
      </div>

      <div className="my-8  w-full border border-b  rounded mb-16">
        <h3 className="bold text-xl border-b mb-8 p-4">Auto Run</h3>
        <div className="px-4 py-3 bg-gray-50 text-right sm:px-6">
          <button
            type="submit"
            onClick={() => runAuto()}
            className="bg-indigo-600 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900"
          >
            Auto Run
          </button>
        </div>
      </div>

      <StoreCollectionsTable salesforce_id={member.salesforce_id} />
    </div>
  );
};
